import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";

const QRCodeSection = ({ token }) => {
  // Construct the URL for the QR code
  const qrCodeUrl = window.location.origin + "/claim/" + token;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        height: "100%",
      }}
    >
      <Typography variant="h5" gutterBottom>
        Shared Dive QR Code
      </Typography>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#f5f5f5",
        }}
      >
        <QRCodeSVG
          id="qrcode"
          value={qrCodeUrl}
          size={200}
          level="H" // High error correction allows for more logo space
          includeMargin={true}
          renderAs="svg"
          fgColor="#0066CC" // Primary QR code color - customize to match your brand
          bgColor="#FFFFFF" // Background color
          imageSettings={{
            src: "/favicon.ico", // Path to your logo
            x: undefined,
            y: undefined,
            height: 40,
            width: 40,
            excavate: true, // This creates space for the logo
          }}
        />

        <Button
          variant="outlined"
          size="small"
          sx={{ mt: 2 }}
          onClick={() => {
            const svg = document.getElementById("qrcode");
            const svgData = new XMLSerializer().serializeToString(svg);
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.onload = () => {
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const pngFile = canvas.toDataURL("image/png");
              const downloadLink = document.createElement("a");
              downloadLink.download = "dive-claim-qrcode.png";
              downloadLink.href = pngFile;
              downloadLink.click();
            };
            img.src = "data:image/svg+xml;base64," + btoa(svgData);
          }}
        >
          Download QR Code
        </Button>
      </Paper>
    </Box>
  );
};

export default QRCodeSection;
